import useAssets from '../../../../../common/useAssets';
const cdn = useAssets(false);


export const contentList = [
    { id: 1, title: '达人版', content: '开放的商业平台，达人可以在平台上自助了解、获取海量的商业合作机会。', url: cdn('images/sharing/pi-1.png', 700) },
    { id: 2, title: '品牌版', content: '全平台达人智能投放营销工具，提供资源推荐、内容审核、数据监控、舆情分析等全流程服务，帮助品牌高效完成尾部达人投放。', url: cdn('images/sharing/pi-2.png', 700) },
    { id: 3, title: '机构端', content: '爱种草用户的数据中台，通过系统沉淀数据，以数据为核心，整合达人资源，解决资源精准度低、海量达人投放、执行体验差等痛点。', url: cdn('images/sharing/pi-3.png', 700) },
    ]
